import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

import "../static/css/theme.css";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ResetPassword() {
  let query = useQuery();

  useEffect(() => {
    if (query.get("token") === "invalid")
      toast.error("Token ivalido, favor ingrese su correo nuevamente");
  }, []);

  const history = useHistory();

  function postReset(values) {
    toast.dismiss();
    axios
      .post("auth/get-token-reset-password", {
        email: values.email,
      })
      .then((result) => {
        if (result.status === 200) {
          toast.success(
            "Se ha enviado un enlace a su correo, favor seguir las instrucciones",
            { duration: 4000 }
          );
          setTimeout(function () {
            history.push("/");
          }, 5000);
        }
      })
      .catch(function (error) {
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        } else if (error.request) {
        }
      });
  }

  const Validaciones = Yup.object().shape({
    email: Yup.string().required("").email("Correo Invalido"),
  });

  return (
    <div className="login">
      <Toaster />
      <div className="container">
        <div className="row">
          <div className="col-sm-12 align-div--middle">
            <div className="login__content-wrapper">
              <div className="logo">KREZCO</div>
              <div className="form form--login form--white form--bordered">
                <Formik
                  initialValues={{
                    email: "",
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    postReset(values);
                    setSubmitting(false);
                  }}
                  validationSchema={Validaciones}
                >
                  {({ isSubmitting }) => (
                    <Form>
                      <div className="form__wrapper">
                        <div className="form__title text-center">
                          ¿Olvidastes tu Contraseña?
                        </div>
                        <div className="form__description text-center">
                          Ingrese la dirección de correo electrónico que utilizó
                          cuando se unió y le enviaremos instrucciones para
                          restablecer su contraseña.
                        </div>
                        <div className="form__row">
                          <label htmlFor="email">Email</label>
                          <Field
                            type="email"
                            name="email"
                            id="email"
                            placeholder="email@email.com"
                            required
                          ></Field>
                          <span className="form__validation"></span>
                        </div>

                        <div className="form__row">
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn btn--gradient btn__icon btn__icon--door"
                          >
                            <i className="fas fa-paper-plane"></i> Enviar
                            Instrucciones
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
              <div className="regular-content text-color--white text-center pt-4">
                ¿Aún no tienes una cuenta?{" "}
                <Link to="/Registrate" className="link-color--purple">
                  Forma parte de la comunidad KREZCO
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
